import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ "seletorGrid", "linha", "selectCategoria", "divAutocomplete",
                    "inputDataInicial", "inputDataFinal",
                    "labelDataFinal", "radioPeriodo",
                    "msgDataInicialInvalida", "msgDataFinalInvalida"]

  initialize() {
    this._onChangeCategoria = this._onChangeCategoria.bind(this)
  }

  connect() {
    this.selectCategoriaTarget.addEventListener('change', this._onChangeCategoria)

    this._aplicarTipoRelacionado()
    this._resolverIntervaloDatas()
    this._validarDataInicial()
    this._validarDataFinal()
    this._bindDatepickerEvents()
  }

  disconnect() {
    this.selectCategoriaTarget.removeEventListener('change', this._onChangeCategoria)
    if (this.hasInputDataInicialTarget) {
      $(this.inputDataInicialTarget).off('change.galeria')
    }
    if (this.hasInputDataFinalTarget) {
      $(this.inputDataFinalTarget).off('change.galeria')
    }
  }

  _onChangeCategoria() {
    this._aplicarTipoRelacionado()
  }

  _aplicarTipoRelacionado() {

    const tipoRelacionado = this.tipoRelacionadoCategoria


    if (tipoRelacionado) {
      this.divAutocompleteTarget
          .querySelector('label')
          .textContent = this._resolveNomeRelacionamento(tipoRelacionado)

      this
        .divAutocompleteTarget
        .setAttribute('data-autocomplete-url', `/galerias/autocomplete.html?tipo_relacionado=${tipoRelacionado}`)

      this.divAutocompleteTarget.classList.remove('oculta')
    }else {
      this.divAutocompleteTarget.classList.add('oculta')
    }

  }

  _resolverIntervaloDatas() {
    // Busca o radio que está marcado no momento
    const radioAtivo = this.element.querySelector('input[name="periodo_selecionado"]:checked')
    
    if (this.hasLabelDataFinalTarget && radioAtivo) {
      const exibir = (radioAtivo.value === 'periodo')
      this.labelDataFinalTarget.classList.toggle('oculta', !exibir)
    }
  }

  _resolveNomeRelacionamento(nome) {

    switch (nome) {
      case 'comissao':
        return 'Comissão'
        break;
      case 'cpi':
        return 'CPI(s)'
        break;
      case 'deputado':
        return 'Deputado(a)'
        break;
      default:
        return ''

    }

  }

  setSeletorAtivo(event) {
    event.preventDefault()

    let elementeRef = event.target
    if (event.target.tagName !== 'div') {
      elementeRef = event.target.closest('div')
    }

    this.seletorGridTargets.forEach(el => el.classList.remove('visualizacao-ativa'))
    elementeRef.classList.add('visualizacao-ativa')


    const gridNumero = parseInt(elementeRef.getAttribute('data-grid-numero'))

    this.linhaTargets.forEach(el => {
      el.classList.remove(`grid-${this.gridAtivoNumero}`)
      el.classList.add(`grid-${gridNumero}`)
    })

    this.gridAtivoNumero = gridNumero
  }

  checarPeriodo() {
    this._resolverIntervaloDatas()
  }

  validarDataInicial() {
    this._validarDataInicial()
  }

  validarDataFinal() {
    this._validarDataFinal()
  }

  _bindDatepickerEvents() {
    // jQuery UI 1.x dispara change via $.trigger(), que não aciona listeners nativos do DOM
    // (usados pelo Stimulus). Por isso usamos o sistema de eventos do próprio jQuery.
    if (this.hasInputDataInicialTarget) {
      $(this.inputDataInicialTarget).on('change.galeria', () => this._validarDataInicial())
    }
    if (this.hasInputDataFinalTarget) {
      $(this.inputDataFinalTarget).on('change.galeria', () => this._validarDataFinal())
    }
  }

  _validarDataInicial() {
    if (!this.hasInputDataInicialTarget || !this.hasMsgDataInicialInvalidaTarget) return
    const invalida = !this._isDataValida(this.inputDataInicialTarget.value)
    this.msgDataInicialInvalidaTarget.classList.toggle('oculta', !invalida)
  }

  _validarDataFinal() {
    if (!this.hasInputDataFinalTarget || !this.hasMsgDataFinalInvalidaTarget) return
    const invalida = !this._isDataValida(this.inputDataFinalTarget.value)
    this.msgDataFinalInvalidaTarget.classList.toggle('oculta', !invalida)
  }

  _isDataValida(valor) {
    if (!valor || valor.trim() === '') return true

    // Formato ISO YYYY-MM-DD (flatpickr armazena no input original neste formato)
    const matchISO = valor.match(/^(\d{4})-(\d{2})-(\d{2})$/)
    if (matchISO) {
      const ano = Number.parseInt(matchISO[1], 10)
      const mes = Number.parseInt(matchISO[2], 10)
      const dia = Number.parseInt(matchISO[3], 10)
      const date = new Date(ano, mes - 1, dia)
      return date.getFullYear() === ano &&
             date.getMonth() === mes - 1 &&
             date.getDate() === dia
    }

    // Formato DD/MM/YYYY (digitação manual ou valor inválido vindo da URL)
    const match = valor.match(/^(\d{2})\/(\d{2})\/(\d{4})$/)
    if (!match) return false

    const dia = Number.parseInt(match[1], 10)
    const mes = Number.parseInt(match[2], 10)
    const ano = Number.parseInt(match[3], 10)
    const date = new Date(ano, mes - 1, dia)

    return date.getFullYear() === ano &&
           date.getMonth() === mes - 1 &&
           date.getDate() === dia
  }


  get seletorAtivo() {
    return this
            .seletorGridTargets
            .find(seletor => seletor.classList.contains('visualizacao-ativa'))
  }

  get gridAtivoNumero() {
    return this.data.get('gridAtivoNumero')
  }

  get tipoRelacionadoCategoria() {
    return this
            .selectCategoriaTarget
            .selectedOptions[0]
            .getAttribute('data-tipo-relacionado')
  }

  get radioPeriodoSelecionado() {
    return this
            .element
            .querySelector("input[name=periodo_selecionado]:checked")
            .value
  }

  set gridAtivoNumero(gridAtivoNumero) {
    this.data.set('gridAtivoNumero', gridAtivoNumero)
  }

}
